export default __webpack_public_path__ + "static/aimychat-favicon-2463362155ee96e2d7ab23eebf5f19dd.ico";